import { useMutation, useQueryClient, type UseMutationResult } from '@tanstack/react-query';
import { createAppointment, updateAppointment } from '@/api/appointments/appointmentsApi';
import { APPOINTMENTS_QUERY_KEY, WORKSPACE_ATTENTION_QUERY_KEY } from '@/constants/queryKeys';
import type { Appointment, AppointmentDraft } from '@/api/appointments/appointmentsApi.types';

interface SaveAppointmentVariables {
  appointmentIdentifier: string | null;
  appointmentDraft: AppointmentDraft;
}

async function saveAppointment(variables: SaveAppointmentVariables): Promise<Appointment> {
  if (variables.appointmentIdentifier === null) {
    return createAppointment(variables.appointmentDraft);
  }
  return updateAppointment(variables.appointmentIdentifier, variables.appointmentDraft);
}

export function useSaveAppointmentMutation(): UseMutationResult<
  Appointment,
  Error,
  SaveAppointmentVariables
> {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: saveAppointment,
    onSuccess: function invalidateAppointmentsCache() {
      queryClient.invalidateQueries({ queryKey: APPOINTMENTS_QUERY_KEY });
      queryClient.invalidateQueries({ queryKey: WORKSPACE_ATTENTION_QUERY_KEY });
    },
  });
}
